import React from 'react';
import { HeroSection } from './components/HeroSection';
import { ProblemSection } from './components/ProblemSection';
import { FailedApproaches } from './components/FailedApproaches';
import { MechanismSection } from './components/MechanismSection';
import { WhatYouGet } from './components/WhatYouGet';
import { WhoIsItFor } from './components/WhoIsItFor';
import { HowItWorks } from './components/HowItWorks';
import { ProofSection } from './components/ProofSection';
import { FAQSection } from './components/FAQSection';
import { OfferSection } from './components/OfferSection';
import { FooterCTA } from './components/FooterCTA';
export function App() {
  return <main className="min-h-screen bg-cream font-sans text-charcoal overflow-x-hidden" data-id="element-0">
      <HeroSection data-id="element-1" />
      <ProblemSection data-id="element-2" />
      <FailedApproaches data-id="element-3" />
      <MechanismSection data-id="element-4" />
      <WhatYouGet data-id="element-5" />
      <WhoIsItFor data-id="element-6" />
      <HowItWorks data-id="element-7" />
      <ProofSection data-id="element-8" />
      <FAQSection data-id="element-9" />
      <OfferSection data-id="element-10" />
      <FooterCTA data-id="element-11" />
    </main>;
}